<script>
import ButtonBasic from "@/components/shared/button/ButtonBasic";

export default {
  name: "ButtonFlat",
  extends: ButtonBasic
};
</script>

<style lang="scss" scoped>
button {
  width: $button-width;
  max-width: $button-max-width;
  padding: 8px;
  text-align: center;
  text-transform: uppercase;
  vertical-align: middle;
  background-color: $background-color-secondary-1;
  border: solid 1px $background-color-secondary-1;
  border-radius: 30px;
  color: $color-primary-1;
  font: inherit;
  cursor: pointer;
  overflow: hidden;
  transition-property: background-color color;
  transition-duration: $button-transition-duration;
  transition-timing-function: $button-transition-timing-function;
  @media only screen and (min-width: $mobile-width) {
    &:hover {
      color: $color-secondary-1;
      background-color: $background-color-clear-1;
    }
  }
}
</style>
